import { useTranslation } from 'react-i18next'
import { formatNumbers } from 'core/helpers/format-numbers'
import cn from 'classnames'
import { useState, useEffect } from 'react'
import { useAuthContext } from '../../../core/providers/AuthProvider'
import { minesService } from '../../../core/services'
import bombImg from '../list/assets/images/mines-bomb.png'

import c from './assets/sass/bet.module.scss'

const DEFAULT_BETS = [
    { amount: 100,  mines: 5 },
    { amount: 500,  mines: 8 },
    { amount: 1000, mines: 10 },
]

const BET_COLORS = ['green', 'orange', 'red']

export const Bet = ({ betHandler }) => {
    const { t } = useTranslation()
    const { user } = useAuthContext()
    const [bets, setBets] = useState(DEFAULT_BETS)
    const [selectedBet, setSelectedBet] = useState(DEFAULT_BETS[0].amount)
    const [pendingConfirm, setPendingConfirm] = useState(false)

    useEffect(() => {
        minesService.getBetConfig()
            .then(data => {
                if (data?.bets?.length) {
                    setBets(data.bets)
                    setSelectedBet(prev => {
                        const amounts = data.bets.map(b => b.amount)
                        return amounts.includes(prev) ? prev : amounts[0]
                    })
                }
            })
            .catch(() => {})
    }, [])

    const handleBetSelect = (amount) => {
        setSelectedBet(amount)
        setPendingConfirm(false)
    }

    const handleStart = () => {
        if (user?.balance < selectedBet) return
        if (!pendingConfirm) {
            setPendingConfirm(true)
            return
        }
        betHandler(selectedBet)
    }

    const isInsufficient = user?.balance < selectedBet

    return (
        <div className={c.component}>
            <div className={c.wrapper}>
                <div className={c.row}>
                    <span className={c.title}>{t('mines.bet.title')}</span>
                    <span className={c.subTitle}>
                        {t('mines.bet.subtitle')}
                    </span>
                    <span className={c.hint}>
                        {t('mines.bet.hint')}
                    </span>
                    <ul className={c.list}>
                        {bets.map(({ amount, mines }, idx) => (
                            <li key={amount} className={c.item}>
                                <button
                                    className={cn(c.button, c[BET_COLORS[idx] || 'green'], {
                                        [c.active]: selectedBet === amount,
                                        [c.disabled]: user?.balance < amount,
                                    })}
                                    onClick={() => handleBetSelect(amount)}
                                    disabled={user?.balance < amount}
                                >
                                    <span>{formatNumbers(amount)}</span>
                                    <div className={c.minesInfo}>
                                        <img src={bombImg} alt="" className={c.bombIcon} />
                                        <span>×{mines}</span>
                                    </div>
                                </button>
                            </li>
                        ))}
                    </ul>
                    <button
                        className={cn(c.start, {
                            [c.disabled]: isInsufficient,
                        })}
                        onClick={handleStart}
                        disabled={isInsufficient}
                    >
                        <span>
                            {isInsufficient
                                ? t('mines.bet.insufficient')
                                : pendingConfirm
                                    ? t('mines.bet.confirm')
                                    : t('mines.bet.start')}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}
